import React from "react";
import { isEmpty } from "lodash";
import {
    useCreateDashboardStore,
} from "..";
import CreateChartModal from "../modal/CreateChart";
import { NetworkSelected } from "types";
import CreateStatus from "./CreateStatus";
import { default as CreateSingleUsage } from "./CreateSingleUsage";
import { default as CreateMultipleUsage } from "./CreateMultipleUsage";
import CreateTimeline from "./CreateTimeline";
import { WidgetType } from "components/dashboard/utils/widgetConfig";


type EventDataChange = {
    chartName: string;
    data?: Array<NetworkSelected>;
}

const PSlCreateComponent = () => {
    const { createModalShow, setCreateModalShow, createData, widget } =
        useCreateDashboardStore();
    const widgetType = widget?.widgetType;

    const renderWidgetByType = () => {
        switch (widgetType) {
            case WidgetType.PSL_TABLE_STATUS:
                return <CreateStatus />;
            case WidgetType.PSL_CHART_SINGLE_ROOM:
                return <CreateSingleUsage />;
            case WidgetType.PSL_CHART_MULTIPLE_ROOM:
                return <CreateMultipleUsage />;
            case WidgetType.PSL_CHART_ROOM_TIMELINE:
                return <CreateTimeline />;
            case WidgetType.PSL_CHART_ZONE_TIMELINE:
                return <CreateTimeline />;
            case WidgetType.PSL_CHART_GROUP_TIMELINE:
                return <CreateTimeline />;
            default:
                return <div>Not supported widget type.</div>;
        }
    }

    return (
        <React.Fragment>
            {renderWidgetByType()}
            <CreateChartModal
                show={createModalShow && !isEmpty(createData)}
                onHide={() => setCreateModalShow(false)}
            />
        </React.Fragment>
    );
};

export type EventOnChange = (data: EventDataChange) => void;
export type EditWidgetProps = {
    panel?: any;
    onChange?: EventOnChange;
}

export { CreateStatus, CreateMultipleUsage };

export default PSlCreateComponent;
